module.exports = __webpack_public_path__ + "static/media/cy.dbf92cb8.svg";